// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bgf_a","AdSlotBranding__desktop":"bgf_b","AdSlotBranding__mobile":"bgf_c"};